export default "__VITE_ASSET__CSRIpB0Z__"